export const isJac = permiso => permiso?.rol?.trim().toUpperCase() === "JAC"
export const canViewModule = (permiso, module) => {
  if (!permiso) return false
  if (isJac(permiso)) return module === "servicios" && !!(permiso.servicios & 1)
  return !!(permiso[module] & 1) || (module === "carrosAreas" && !!((permiso.areas | permiso.carros) & 1))
}
